// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/gig_card_component.proto" (package "bianka.event.activity.v2.extension", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SellerLevel } from "../../../../enums/listing/seller_level";
import { Engine } from "../../../../enums/gig/engine";
import { Badge } from "../../../../enums/gig/badge";
import { Gig } from "../../../../core/enrichment/gig";
/**
 * Next serial number to be used: 4
 *
 * @generated from protobuf message bianka.event.activity.v2.extension.GigCardComponent
 */
export interface GigCardComponent {
    /**
     * Gig's enrichment
     *
     * @generated from protobuf field: bianka.core.enrichment.Gig gig = 1
     */
    gig?: Gig;
    /**
     * Data regarding the gig card
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes gig_card_attributes = 3
     */
    gigCardAttributes?: GigCardComponent_GigCardAttributes;
    /**
     * Seller's enrichment
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.GigCardComponent.Seller seller = 4
     */
    seller?: GigCardComponent_Seller;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes
 */
export interface GigCardComponent_GigCardAttributes {
    /**
     * The shown price
     *
     * @generated from protobuf field: double shown_price = 1
     */
    shownPrice: number;
    /**
     * The price in usd
     *
     * @generated from protobuf field: double price_usd = 2
     */
    priceUsd: number;
    /**
     * The shown package id
     *
     * @generated from protobuf field: int32 shown_package = 3
     */
    shownPackage: number;
    /**
     * The shown rated orders
     *
     * @generated from protobuf field: string shown_rated_orders = 4
     */
    shownRatedOrders: string;
    /**
     * The shown rating
     *
     * @generated from protobuf field: double shown_rating = 5
     */
    shownRating: number;
    /**
     * Indicates if the gig's seller is online
     *
     * @generated from protobuf field: bool is_online = 6
     */
    isOnline: boolean;
    /**
     * The shown badges list
     *
     * @generated from protobuf field: repeated bianka.enums.gig.Badge badges = 7
     */
    badges: Badge[];
    /**
     * The engine that set the allocation
     *
     * @generated from protobuf field: bianka.enums.gig.Engine engine = 8
     */
    engine: Engine;
    /**
     * Data regarding the attachment
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Attachment attachment = 9
     */
    attachment?: GigCardComponent_GigCardAttributes_Attachment;
    /**
     * The price bucket of the component (only relevant to price-bucket placement gigs)
     *
     * @generated from protobuf field: optional string price_bucket = 10
     */
    priceBucket?: string;
    /**
     * Auction data for promoted gig
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Auction auction = 11
     */
    auction?: GigCardComponent_GigCardAttributes_Auction;
    /**
     * Seller speaks displayed languages
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.SellerDisplayedLanguage seller_displayed_languages = 12
     */
    sellerDisplayedLanguages: GigCardComponent_GigCardAttributes_SellerDisplayedLanguage[];
    /**
     * The amount of images in the gig
     *
     * @generated from protobuf field: int32 images_count = 13
     */
    imagesCount: number;
    /**
     * The amount of videos in the gig
     *
     * @generated from protobuf field: int32 videos_count = 14
     */
    videosCount: number;
    /**
     * Translation layer data
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.TranslationLayer translation_layer = 15
     */
    translationLayer?: GigCardComponent_GigCardAttributes_TranslationLayer;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Attachment
 */
export interface GigCardComponent_GigCardAttributes_Attachment {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bool is_default = 2
     */
    isDefault: boolean;
    /**
     * @generated from protobuf field: bool is_video = 3
     */
    isVideo: boolean;
    /**
     * @generated from protobuf field: bool is_tagged = 4
     */
    isTagged: boolean;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Auction
 */
export interface GigCardComponent_GigCardAttributes_Auction {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.SellerDisplayedLanguage
 */
export interface GigCardComponent_GigCardAttributes_SellerDisplayedLanguage {
    /**
     * @generated from protobuf field: string language_code = 1
     */
    languageCode: string;
    /**
     * @generated from protobuf field: int32 position = 2
     */
    position: number;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.TranslationLayer
 */
export interface GigCardComponent_GigCardAttributes_TranslationLayer {
    /**
     * @generated from protobuf field: string title = 1
     */
    title: string;
    /**
     * @generated from protobuf field: int32 images_count = 2
     */
    imagesCount: number;
    /**
     * @generated from protobuf field: int32 videos_count = 3
     */
    videosCount: number;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.GigCardComponent.Seller
 */
export interface GigCardComponent_Seller {
    /**
     * @generated from protobuf field: int32 id = 1
     */
    id: number;
    /**
     * @generated from protobuf field: optional string country = 2
     */
    country?: string;
    /**
     * @generated from protobuf field: optional bool is_pro = 3
     */
    isPro?: boolean;
    /**
     * @generated from protobuf field: bianka.enums.listing.SellerLevel seller_level = 5
     */
    sellerLevel: SellerLevel;
}
// @generated message type with reflection information, may provide speed optimized methods
class GigCardComponent$Type extends MessageType<GigCardComponent> {
    constructor() {
        super("bianka.event.activity.v2.extension.GigCardComponent", [
            { no: 1, name: "gig", kind: "message", T: () => Gig },
            { no: 3, name: "gig_card_attributes", kind: "message", T: () => GigCardComponent_GigCardAttributes },
            { no: 4, name: "seller", kind: "message", T: () => GigCardComponent_Seller }
        ]);
    }
    create(value?: PartialMessage<GigCardComponent>): GigCardComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GigCardComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GigCardComponent): GigCardComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bianka.core.enrichment.Gig gig */ 1:
                    message.gig = Gig.internalBinaryRead(reader, reader.uint32(), options, message.gig);
                    break;
                case /* bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes gig_card_attributes */ 3:
                    message.gigCardAttributes = GigCardComponent_GigCardAttributes.internalBinaryRead(reader, reader.uint32(), options, message.gigCardAttributes);
                    break;
                case /* bianka.event.activity.v2.extension.GigCardComponent.Seller seller */ 4:
                    message.seller = GigCardComponent_Seller.internalBinaryRead(reader, reader.uint32(), options, message.seller);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GigCardComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bianka.core.enrichment.Gig gig = 1; */
        if (message.gig)
            Gig.internalBinaryWrite(message.gig, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes gig_card_attributes = 3; */
        if (message.gigCardAttributes)
            GigCardComponent_GigCardAttributes.internalBinaryWrite(message.gigCardAttributes, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bianka.event.activity.v2.extension.GigCardComponent.Seller seller = 4; */
        if (message.seller)
            GigCardComponent_Seller.internalBinaryWrite(message.seller, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.GigCardComponent
 */
export const GigCardComponent = new GigCardComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GigCardComponent_GigCardAttributes$Type extends MessageType<GigCardComponent_GigCardAttributes> {
    constructor() {
        super("bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes", [
            { no: 1, name: "shown_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "price_usd", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "shown_package", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "shown_rated_orders", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "shown_rating", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "is_online", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "badges", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["bianka.enums.gig.Badge", Badge, "BADGE_"] },
            { no: 8, name: "engine", kind: "enum", T: () => ["bianka.enums.gig.Engine", Engine, "ENGINE_"] },
            { no: 9, name: "attachment", kind: "message", T: () => GigCardComponent_GigCardAttributes_Attachment },
            { no: 10, name: "price_bucket", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "auction", kind: "message", T: () => GigCardComponent_GigCardAttributes_Auction },
            { no: 12, name: "seller_displayed_languages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GigCardComponent_GigCardAttributes_SellerDisplayedLanguage },
            { no: 13, name: "images_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "videos_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "translation_layer", kind: "message", T: () => GigCardComponent_GigCardAttributes_TranslationLayer }
        ]);
    }
    create(value?: PartialMessage<GigCardComponent_GigCardAttributes>): GigCardComponent_GigCardAttributes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shownPrice = 0;
        message.priceUsd = 0;
        message.shownPackage = 0;
        message.shownRatedOrders = "";
        message.shownRating = 0;
        message.isOnline = false;
        message.badges = [];
        message.engine = 0;
        message.sellerDisplayedLanguages = [];
        message.imagesCount = 0;
        message.videosCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GigCardComponent_GigCardAttributes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GigCardComponent_GigCardAttributes): GigCardComponent_GigCardAttributes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double shown_price */ 1:
                    message.shownPrice = reader.double();
                    break;
                case /* double price_usd */ 2:
                    message.priceUsd = reader.double();
                    break;
                case /* int32 shown_package */ 3:
                    message.shownPackage = reader.int32();
                    break;
                case /* string shown_rated_orders */ 4:
                    message.shownRatedOrders = reader.string();
                    break;
                case /* double shown_rating */ 5:
                    message.shownRating = reader.double();
                    break;
                case /* bool is_online */ 6:
                    message.isOnline = reader.bool();
                    break;
                case /* repeated bianka.enums.gig.Badge badges */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.badges.push(reader.int32());
                    else
                        message.badges.push(reader.int32());
                    break;
                case /* bianka.enums.gig.Engine engine */ 8:
                    message.engine = reader.int32();
                    break;
                case /* bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Attachment attachment */ 9:
                    message.attachment = GigCardComponent_GigCardAttributes_Attachment.internalBinaryRead(reader, reader.uint32(), options, message.attachment);
                    break;
                case /* optional string price_bucket */ 10:
                    message.priceBucket = reader.string();
                    break;
                case /* bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Auction auction */ 11:
                    message.auction = GigCardComponent_GigCardAttributes_Auction.internalBinaryRead(reader, reader.uint32(), options, message.auction);
                    break;
                case /* repeated bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.SellerDisplayedLanguage seller_displayed_languages */ 12:
                    message.sellerDisplayedLanguages.push(GigCardComponent_GigCardAttributes_SellerDisplayedLanguage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 images_count */ 13:
                    message.imagesCount = reader.int32();
                    break;
                case /* int32 videos_count */ 14:
                    message.videosCount = reader.int32();
                    break;
                case /* bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.TranslationLayer translation_layer */ 15:
                    message.translationLayer = GigCardComponent_GigCardAttributes_TranslationLayer.internalBinaryRead(reader, reader.uint32(), options, message.translationLayer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GigCardComponent_GigCardAttributes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double shown_price = 1; */
        if (message.shownPrice !== 0)
            writer.tag(1, WireType.Bit64).double(message.shownPrice);
        /* double price_usd = 2; */
        if (message.priceUsd !== 0)
            writer.tag(2, WireType.Bit64).double(message.priceUsd);
        /* int32 shown_package = 3; */
        if (message.shownPackage !== 0)
            writer.tag(3, WireType.Varint).int32(message.shownPackage);
        /* string shown_rated_orders = 4; */
        if (message.shownRatedOrders !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.shownRatedOrders);
        /* double shown_rating = 5; */
        if (message.shownRating !== 0)
            writer.tag(5, WireType.Bit64).double(message.shownRating);
        /* bool is_online = 6; */
        if (message.isOnline !== false)
            writer.tag(6, WireType.Varint).bool(message.isOnline);
        /* repeated bianka.enums.gig.Badge badges = 7; */
        if (message.badges.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.badges.length; i++)
                writer.int32(message.badges[i]);
            writer.join();
        }
        /* bianka.enums.gig.Engine engine = 8; */
        if (message.engine !== 0)
            writer.tag(8, WireType.Varint).int32(message.engine);
        /* bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Attachment attachment = 9; */
        if (message.attachment)
            GigCardComponent_GigCardAttributes_Attachment.internalBinaryWrite(message.attachment, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* optional string price_bucket = 10; */
        if (message.priceBucket !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.priceBucket);
        /* bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Auction auction = 11; */
        if (message.auction)
            GigCardComponent_GigCardAttributes_Auction.internalBinaryWrite(message.auction, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.SellerDisplayedLanguage seller_displayed_languages = 12; */
        for (let i = 0; i < message.sellerDisplayedLanguages.length; i++)
            GigCardComponent_GigCardAttributes_SellerDisplayedLanguage.internalBinaryWrite(message.sellerDisplayedLanguages[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* int32 images_count = 13; */
        if (message.imagesCount !== 0)
            writer.tag(13, WireType.Varint).int32(message.imagesCount);
        /* int32 videos_count = 14; */
        if (message.videosCount !== 0)
            writer.tag(14, WireType.Varint).int32(message.videosCount);
        /* bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.TranslationLayer translation_layer = 15; */
        if (message.translationLayer)
            GigCardComponent_GigCardAttributes_TranslationLayer.internalBinaryWrite(message.translationLayer, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes
 */
export const GigCardComponent_GigCardAttributes = new GigCardComponent_GigCardAttributes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GigCardComponent_GigCardAttributes_Attachment$Type extends MessageType<GigCardComponent_GigCardAttributes_Attachment> {
    constructor() {
        super("bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Attachment", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "is_default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "is_video", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "is_tagged", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GigCardComponent_GigCardAttributes_Attachment>): GigCardComponent_GigCardAttributes_Attachment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.isDefault = false;
        message.isVideo = false;
        message.isTagged = false;
        if (value !== undefined)
            reflectionMergePartial<GigCardComponent_GigCardAttributes_Attachment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GigCardComponent_GigCardAttributes_Attachment): GigCardComponent_GigCardAttributes_Attachment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool is_default */ 2:
                    message.isDefault = reader.bool();
                    break;
                case /* bool is_video */ 3:
                    message.isVideo = reader.bool();
                    break;
                case /* bool is_tagged */ 4:
                    message.isTagged = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GigCardComponent_GigCardAttributes_Attachment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool is_default = 2; */
        if (message.isDefault !== false)
            writer.tag(2, WireType.Varint).bool(message.isDefault);
        /* bool is_video = 3; */
        if (message.isVideo !== false)
            writer.tag(3, WireType.Varint).bool(message.isVideo);
        /* bool is_tagged = 4; */
        if (message.isTagged !== false)
            writer.tag(4, WireType.Varint).bool(message.isTagged);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Attachment
 */
export const GigCardComponent_GigCardAttributes_Attachment = new GigCardComponent_GigCardAttributes_Attachment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GigCardComponent_GigCardAttributes_Auction$Type extends MessageType<GigCardComponent_GigCardAttributes_Auction> {
    constructor() {
        super("bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Auction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GigCardComponent_GigCardAttributes_Auction>): GigCardComponent_GigCardAttributes_Auction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GigCardComponent_GigCardAttributes_Auction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GigCardComponent_GigCardAttributes_Auction): GigCardComponent_GigCardAttributes_Auction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GigCardComponent_GigCardAttributes_Auction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.Auction
 */
export const GigCardComponent_GigCardAttributes_Auction = new GigCardComponent_GigCardAttributes_Auction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GigCardComponent_GigCardAttributes_SellerDisplayedLanguage$Type extends MessageType<GigCardComponent_GigCardAttributes_SellerDisplayedLanguage> {
    constructor() {
        super("bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.SellerDisplayedLanguage", [
            { no: 1, name: "language_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GigCardComponent_GigCardAttributes_SellerDisplayedLanguage>): GigCardComponent_GigCardAttributes_SellerDisplayedLanguage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.languageCode = "";
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<GigCardComponent_GigCardAttributes_SellerDisplayedLanguage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GigCardComponent_GigCardAttributes_SellerDisplayedLanguage): GigCardComponent_GigCardAttributes_SellerDisplayedLanguage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string language_code */ 1:
                    message.languageCode = reader.string();
                    break;
                case /* int32 position */ 2:
                    message.position = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GigCardComponent_GigCardAttributes_SellerDisplayedLanguage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string language_code = 1; */
        if (message.languageCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.languageCode);
        /* int32 position = 2; */
        if (message.position !== 0)
            writer.tag(2, WireType.Varint).int32(message.position);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.SellerDisplayedLanguage
 */
export const GigCardComponent_GigCardAttributes_SellerDisplayedLanguage = new GigCardComponent_GigCardAttributes_SellerDisplayedLanguage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GigCardComponent_GigCardAttributes_TranslationLayer$Type extends MessageType<GigCardComponent_GigCardAttributes_TranslationLayer> {
    constructor() {
        super("bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.TranslationLayer", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "images_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "videos_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GigCardComponent_GigCardAttributes_TranslationLayer>): GigCardComponent_GigCardAttributes_TranslationLayer {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.title = "";
        message.imagesCount = 0;
        message.videosCount = 0;
        if (value !== undefined)
            reflectionMergePartial<GigCardComponent_GigCardAttributes_TranslationLayer>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GigCardComponent_GigCardAttributes_TranslationLayer): GigCardComponent_GigCardAttributes_TranslationLayer {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string title */ 1:
                    message.title = reader.string();
                    break;
                case /* int32 images_count */ 2:
                    message.imagesCount = reader.int32();
                    break;
                case /* int32 videos_count */ 3:
                    message.videosCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GigCardComponent_GigCardAttributes_TranslationLayer, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string title = 1; */
        if (message.title !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.title);
        /* int32 images_count = 2; */
        if (message.imagesCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.imagesCount);
        /* int32 videos_count = 3; */
        if (message.videosCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.videosCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.GigCardComponent.GigCardAttributes.TranslationLayer
 */
export const GigCardComponent_GigCardAttributes_TranslationLayer = new GigCardComponent_GigCardAttributes_TranslationLayer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GigCardComponent_Seller$Type extends MessageType<GigCardComponent_Seller> {
    constructor() {
        super("bianka.event.activity.v2.extension.GigCardComponent.Seller", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "country", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_pro", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "seller_level", kind: "enum", T: () => ["bianka.enums.listing.SellerLevel", SellerLevel, "SELLER_LEVEL_"] }
        ]);
    }
    create(value?: PartialMessage<GigCardComponent_Seller>): GigCardComponent_Seller {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.sellerLevel = 0;
        if (value !== undefined)
            reflectionMergePartial<GigCardComponent_Seller>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GigCardComponent_Seller): GigCardComponent_Seller {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* optional string country */ 2:
                    message.country = reader.string();
                    break;
                case /* optional bool is_pro */ 3:
                    message.isPro = reader.bool();
                    break;
                case /* bianka.enums.listing.SellerLevel seller_level */ 5:
                    message.sellerLevel = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GigCardComponent_Seller, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* optional string country = 2; */
        if (message.country !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.country);
        /* optional bool is_pro = 3; */
        if (message.isPro !== undefined)
            writer.tag(3, WireType.Varint).bool(message.isPro);
        /* bianka.enums.listing.SellerLevel seller_level = 5; */
        if (message.sellerLevel !== 0)
            writer.tag(5, WireType.Varint).int32(message.sellerLevel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.GigCardComponent.Seller
 */
export const GigCardComponent_Seller = new GigCardComponent_Seller$Type();
